import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '../common/components/buttons';
import useStyles from './HelpPage.styles';

const HelpPage = () => {
  const classes = useStyles();
  const history = useHistory();
  useEffect(() => {
    const helpForm = document.createElement('script');
    helpForm.setAttribute('src', 'https://flyscan.youtrack.cloud/static/simplified/form/form-entry.js');
    helpForm.setAttribute('id', '3ff74515-66c9-41b0-aeaa-1f61026c6600');
    helpForm.setAttribute('data-yt-url', 'https://flyscan.youtrack.cloud');
    helpForm.setAttribute('data-theme', 'light');
    helpForm.setAttribute('data-lang', 'en');
    document.getElementById('formYouTrack').appendChild(helpForm);
  });
  return (
    <>
      <div className={classes.buttonRowContainer}>
        <Button className={classes.buttonRow} primary type="button" onClick={() => history.goBack()}>
          Go back
        </Button>
      </div>
      <div className={classes.root}>
        <h2 className={classes.title}>Help/Support</h2>
        <p className={classes.subTitle}>If you need help or if you want to report a bug, please fill the form below</p>
        <div id="formYouTrack" />
      </div>
    </>
  );
};

export default React.memo(HelpPage);
